__turbopack_context__.v({
  "btn": "CompleteYourProfile-module-scss-module__nqn5Bq__btn",
  "control": "CompleteYourProfile-module-scss-module__nqn5Bq__control",
  "description": "CompleteYourProfile-module-scss-module__nqn5Bq__description",
  "left": "CompleteYourProfile-module-scss-module__nqn5Bq__left",
  "mobileDescWrapper": "CompleteYourProfile-module-scss-module__nqn5Bq__mobileDescWrapper",
  "mobileDetails": "CompleteYourProfile-module-scss-module__nqn5Bq__mobileDetails",
  "primary": "CompleteYourProfile-module-scss-module__nqn5Bq__primary",
  "right": "CompleteYourProfile-module-scss-module__nqn5Bq__right",
  "root": "CompleteYourProfile-module-scss-module__nqn5Bq__root",
  "title": "CompleteYourProfile-module-scss-module__nqn5Bq__title",
});
